export const TOP_SPACE_WITH_TICKER = [11, 12, 14];
